import { inject, Injectable } from '@angular/core';

import { EMPTY, Observable, of, tap } from 'rxjs';

import { ModalService } from '@app/core/ui/components/modal';
import { BuyConfirmationModalComponent } from '@app/shared/components/buy-confirmation-modal/buy-confirmation-modal.component';

import { EskolareCheckoutStrategyService } from './checkout-strategy.interface';
import {
  EskolareShopCheckoutResponse,
  isEskolareShopCheckoutResponse
} from '../../models/shop-checkout-response.model';

@Injectable()
export class EskolareCheckoutService
  implements EskolareCheckoutStrategyService
{
  private readonly modal = inject(ModalService);

  execute(response: EskolareShopCheckoutResponse): Observable<void> {
    if (!response.redirectUrl) {
      return EMPTY;
    }

    return of(undefined).pipe(
      tap(() => {
        this.modal.open(BuyConfirmationModalComponent, {
          options: {
            disableBackdropClose: true,
            backgroundColor: 'transparent',
            size: 'sm'
          },
          data: {
            redirectUrl: response.redirectUrl
          }
        });
      })
    );
  }

  static isValidResponse(
    response: EskolareShopCheckoutResponse
  ): response is EskolareShopCheckoutResponse {
    return isEskolareShopCheckoutResponse(response) && !!response.redirectUrl;
  }
}
